 'use strict';

angular.module('harriApp')
    .factory('resume', ['httpHelper', '$q', '$timeout', function(httpHelper, $q, $timeout, $rootScope) {
        var resume = {};
        var profilePicUUID = null;
        
        resume.autofillApplication = function(resumeData, application, collabsedSections) {
            //we shell nonfod o5t el application according to the resume data
            //autofill references
            if (resumeData.references && resumeData.references[0]) {
                //first make sure to empty the references
                application.references = [];

                angular.forEach(resumeData.references, function(reference, key) {
                    var newRefernce = {
                        name: reference
                    };

                    application.references.push(newRefernce)
                });
            }

            //autofill skills
            if (resumeData.skills && resumeData.skills[0]) {
                application.skills.skills = resumeData.skills;
                //show skills sections accordion
                //for some reasons that i dont understand, collapesd class is added when the flag is false
                collabsedSections.has_skills = false;
            }

            //autofill education
            if (resumeData.education && resumeData.education[0]) {

                var resumeEducation = [];
                angular.forEach(resumeData.education, function(institution, key) {
                    var newEducation = {
                        degree_id: Utils.capitalize(institution.degree) || '',
                        discipline: Utils.capitalize(institution.area_of_study) || '',
                        start_date: institution.start_date,
                        end_date: institution.end_date,
                        institute: {
                            label: Utils.capitalize(institution.institue_name) || '',
                            institution_name: Utils.capitalize(institution.institue_name) || ''
                        }
                    };
                    //update application scope
                    resumeEducation.push(newEducation)
                });

                if (resumeEducation[0]) {
                    application.education.institutions = resumeEducation;
                    //open education section accordion
                    //for some reasons that i dont understand, collapesd class is added when the flag is false
                    collabsedSections.education = false;

                }
            }

            if (resumeData.work_history && resumeData.work_history[0]) {
                
                //remove first_job check if work history data exist
                if (application.work_history.first_job) {
                    application.work_history.first_job = false;
                }

                //empty existing work history if any
                var resumeWorkHistory = []
                angular.forEach(resumeData.work_history, function(work, key) {
                    //check for employer property as well, beacuase no employer no party
                    if (!_.isEmpty(work) && work.employer) {

                        if (work.responsibilities) {
                            work.responsibilities = work.responsibilities.replace(/  /g, " ");

                            if (work.responsibilities.length > 297) {
                                //get 300 charcters max
                                work.responsibilities = work.responsibilities.substr(0, 297) + "...";
                            }
                        }

                        var newWork = {
                            brand: {
                                brand_name: Utils.capitalize(work.employer) || '',
                                label: Utils.capitalize(work.employer) || ''
                            },
                            description: work.responsibilities ? work.responsibilities : '',
                            start_date: work.start_date || '',
                            end_date: work.end_date || '',
                            position_id: '',
                            still_work_here: work.present_job || false
                        };

                        //position might bee an object that already exist in the db, in this case it will exist in position key
                        if (work.position) {
                            newWork.position_id = work.position;
                            newWork.position_id['value'] = work.position.id
                        }
                        //or esle it might be a position that doesn't exist in the db, in this case it will be just a string in user_position key
                        else if (work.user_position) {
                            newWork.position_id = {
                                custom_position: Utils.capitalize(work.user_position),
                                name: Utils.capitalize(work.user_position)
                            }
                        }
                        //update application scope data
                        resumeWorkHistory.push(newWork);
                    }
                });
                 
                    if (resumeWorkHistory[0]){
                        application.work_history.work_histories = resumeWorkHistory;
                    }
             }

            return application;

         };

         //build mobule application object to make it look like the desktop version object
         resume.autofillMobileWorkHistory = function(workHistoryData) {
             var resumeWorkHistory = []
             
             //empty existing work history if any
             
            angular.forEach(workHistoryData, function(work, key) {
                if (!_.isEmpty(work)) {
                    
                    var newWork = {
                        description: work.responsibilities || '',
                        start_date: work.start_date || '',
                        end_date: work.end_date || '',
                        currently: work.present_job || false
                    };

                    //add brand property only if emplyer property was returned from the backend, this way the validator will be able to validate this field properly
                    if (work.employer) {
                        newWork.brand = {
                            brand_name: Utils.capitalize(work.employer),
                            label: Utils.capitalize(work.employer)
                        };
                    }
                    
                    //position might bee an object that already exist in the db, in this case it will exist in position key
                    if (work.position) {
                        newWork.position = work.position;
                    }
                    //or esle it might be a position that doesn't exist in the db, in this case it will be just a string in user_position key
                    else if (work.user_position) {
                        newWork.position = {
                            custom_position: Utils.capitalize(work.user_position),
                            name: Utils.capitalize(work.user_position)
                        }
                    }
                    //update application scope data
                    resumeWorkHistory.push(newWork);
                }
            });
             
            return resumeWorkHistory;
        };

         resume.autofillMobileRefernces = function(referencesData) {
            //first make sure to empty the references
            var references = [];

            angular.forEach(referencesData, function(reference, key) {
                var newRefernce = {
                    name: Utils.capitalize(reference)
                };

                references.push(newRefernce)
            });
             
            return references;

        };

        resume.setProfilePicUUID = function(picUUID) {
            profilePicUUID = picUUID;
        };
        
        resume.getProfilePicUUID = function() {
            return profilePicUUID;
        }

        var is_privacy_shield;

        resume.setPrivacyShield = function (isPrivacyShield) {
            is_privacy_shield = isPrivacyShield;
        };

        resume.leftOversConditions = function(application, hasPhoto) {

            var workHistory = application.work_history.work_histories || [];
            var references = application.references || [];
            return [
                       {
                            data: workHistory[0],
                            text: $filter("translate")("Work History")
                       },
                       {
                            data: application.schedule,
                            text: $filter("translate")("Availability")
                       },
                       {
                            data: application.education.institutions[0],
                            text: $filter("translate")("Education")
                       },
                       {
                            data: (is_privacy_shield)? {is_privacy_shield: "isPrivacyShield"} : references[0],
                            text: $filter("translate")("References"),
                       },
                   ]

        };

        return resume

     }]);